import React, { useEffect, useState, useMemo } from 'react';
import { Tabs, Col, Row, Button, Modal, Checkbox, Typography, Divider, Grid, message } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { DownloadOutlined, CaretRightOutlined } from '@ant-design/icons';
import zhTW from 'antd/es/locale/zh_TW'; // 引入语言包
import LocaleProvider from "antd/es/locale-provider";
import 'antd/dist/antd.css';
import './index.css';
import styled from 'styled-components';
import axios from 'axios';
import { Poems1, Poems2, Poems3,Poems4 } from './Poems';
import { useRef } from 'react';
const { Title, Paragraph, Text, Link } = Typography;
const { useBreakpoint } = Grid;

const CustomTabs = styled.div`
    .ant-tabs-tab{
        font-size :24px;
        font-weight: 700;
        border-radius: 10px;
        background-color: #D9B3B3;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active{
        font-size :30px;
        font-weight: 700;
        background-color: #D9B3B3 !important;
        border-radius: 20px;
    }
    .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab{
      padding:15px;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
      color:#FFFFFF;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab{
      background:#FFF4C1;
      font-size :30px;
    }
    .ant-tabs-tab:hover {
        color: #bbb;
        background: #FFF
    }
    .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:focus, .ant-tabs-tab-btn:active, .ant-tabs-tab-remove:active {
        color: #FFF;
    }
`;
const Check = styled.div`
.ant-checkbox-wrapper{
    font-size: 16px;
}
`;

// const api = "http://localhost:8081"
const api = ""
const Poem = ({
    pageName = "poetry_reading"
}) => {
    const [audio, set_audio] = useState(null);
    const [open, setOpen] = useState(false);
    const [open_player, set_open_player] = useState({
        古詩: false,
        五言絕句: false,
        七言絕句: false,
        五言律詩: false,
        七言律詩: false,
        詞: false
    });
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [clicked_poem, set_clicked_poem] = useState([]);
    const [topic, setTopic] = useState('古詩');
    const [index, setIndex] = useState(null);
    const [data, setData] = useState(null)
    const [MenuItem, setMenuItem] = useState([])
    const buttonstyle = { background: '#FFA600', borderRadius: '10px' }
    const screens = useBreakpoint();

    useEffect(() => {
        getpoem()
    }, [open])
    const play = (file, name, topic) => {
        // set_audio('');
        set_audio(`/music${file}.mp3`);
        patchPlayTime(name)
        if (file !== "") {
            set_open_player(pre => {
                return { ...pre, [topic]: true }
            });
        }
        else {
            set_open_player(pre => {
                return { ...pre, [topic]: false }
            });
        }

    }
    const handleOk = () => {
        getpoem()
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);
        }, 2000);
    }

    const patchPlayTime = (poem_name) => {
        axios.patch(`${api}/poem_plays`, {
            name: poem_name
        })
            .then(response => {

            })
            .catch((error) => {
                // console.error(error)
            })
            .finally(() => {
            })
    }
    const setMenu = (poem) => {
        const mapping_table = {
            古詩: "1",
            五言絕句: "2",
            七言絕句: "3",
            五言律詩: "4",
            七言律詩: "5",
            詞: "6"
        }
        axios.get(`${api}/total_poems`)
            .then(response => {
                Object.keys(poem).map((key, _) => {
                    let poem_type_id = mapping_table[key]
                    poem[key].map((val, index) => {
                        let poem_temp = response.data.filter(element => element.poem_name === `1203_CH${poem_type_id}-${index + 1}` ||
                            element.poem_name === `1203_TW${poem_type_id}-${index + 1}` ||
                            element.poem_name === `1203_HA${poem_type_id}-${index + 1}`)
                        let times = {
                            播放次數: {
                                TW: 0,
                                CH: 0,
                                HA: 0
                            },
                            下載次數: {
                                TW: 0,
                                CH: 0,
                                HA: 0
                            }
                        }
                        poem_temp.map((info, _) => {
                            if (info.poem_name.includes("CH")) {
                                times.播放次數.CH = info.play_times
                                times.下載次數.CH = info.download_times
                            }
                            else if (info.poem_name.includes("TW")) {
                                times.播放次數.TW = info.play_times
                                times.下載次數.TW = info.download_times
                            }
                            else {
                                times.播放次數.HA = info.play_times
                                times.下載次數.HA = info.download_times
                            }
                        })
                        poem[key][index] = { ...val, ...times }
                    })
                })

                setMenuItem(poem);
                setData(poem)
            })
            .catch((error) => {
                // console.error(error) 
            })
            .finally(() => {
            })
    }
    const changeTabs = (topic) => {
        set_open_player({
            古詩: false,
            五言絕句: false,
            七言絕句: false,
            五言律詩: false,
            七言律詩: false,
            詞: false
        });
        setTopic(topic)
        set_clicked_poem([])
        getpoem()
    }
    const getpoem = () => {
        if (pageName === "poetry_reading") {
            setMenu(Poems1)
        }
        else if (pageName === "poetry_music_reading") {
            setMenu(Poems2)
        }
        else if (pageName === "ancient_chinese_reading") {
            setMenu(Poems3)
        }
        else if (pageName === "rhythm_enlightenment") {
            setMenu(Poems4)
        }
        // axios.get(`/poem.json`, {})
        //     .then(response => {
        //         setMenu(response.data)
        //     })
        //     .catch((error) => { 
        //         // console.error(error) 
        //     })
        //     .finally(() => {
        //     })
    }
    useEffect(() => {
        let poemJson 
        if (pageName === "poetry_reading") {
            poemJson =Poems1  
        }
        else if (pageName === "poetry_music_reading") {
            poemJson =Poems2  

        }
        else if (pageName === "ancient_chinese_reading") {
            poemJson =Poems3  
        }
        else if (pageName === "rhythm_enlightenment") {
            poemJson =Poems4
        }
        let poemArray = Object.keys(poemJson)
        changeTabs(poemArray[0])
    }, [pageName])
    return (
        <>
            < DownloadModal
                topic={topic}
                setData={setData}
                data={data || []}
                handleOk={handleOk}
                open={open}
                confirmLoading={confirmLoading}
                setOpen={setOpen}
            />
            <Content
                style={{
                    background: '#FFF4C1',
                    padding: 10
                }}>
                <CustomTabs>
                    <LocaleProvider locale={zhTW}>
                        <Row>
                            <Col
                                // style={{ padding: '20px' }} 
                                span={24}>
                                <Tabs
                                    type="card"
                                    // onTabClick={key => { changeTabs(key) }}
                                    onChange={key => { changeTabs(key) }}
                                    items={
                                        Object.keys(MenuItem).map((value, key) => {
                                            return {
                                                label: value,
                                                key: value,
                                                children:
                                                    <Row gutter={[16, 16]}>
                                                        <Col span={24}>
                                                            <Row gutter={[32, 16]}>
                                                                <Col >
                                                                    <Button onClick={e => {
                                                                        if (pageName === "poetry_reading") {
                                                                            setTopic(value);
                                                                            setIndex(key);
                                                                            setOpen(true)
                                                                        }
                                                                        else {
                                                                            message.info("目前沒有音檔可以下載")
                                                                        }
                                                                    }}
                                                                        icon={<DownloadOutlined />}
                                                                        size={'large'}
                                                                        style={buttonstyle}>
                                                                        下載音檔
                                                                    </Button>
                                                                </Col>
                                                                <Col >
                                                                    <Button
                                                                        size='large'
                                                                        shape="round"
                                                                        icon={<CaretRightOutlined />}
                                                                        onClick={(e) => {
                                                                            if (pageName === "poetry_reading") {
                                                                                play(`/1203CH/1203_CH${key + 1}-${clicked_poem[0].key}`, `1203_CH${key + 1}-${clicked_poem[0].key}`, value)
                                                                            }
                                                                            else {
                                                                                message.info("目前沒有音檔可以播放")
                                                                            }
                                                                        }}
                                                                        style={{ background: '#C4C4C4', }}>
                                                                        播放國語
                                                                    </Button>
                                                                </Col>
                                                                <Col >
                                                                    <Button
                                                                        size='large'
                                                                        shape="round"
                                                                        icon={<CaretRightOutlined />}
                                                                        onClick={(e) => {
                                                                            if (pageName === "poetry_reading") {
                                                                                play(`/1203TW/1203_TW${key + 1}-${clicked_poem[0].key}`, `1203_TW${key + 1}-${clicked_poem[0].key}`, value)
                                                                            }
                                                                            else {
                                                                                message.info("目前沒有音檔可以播放")
                                                                            }
                                                                        }}
                                                                        style={{ background: '#C4C4C4', }}>
                                                                        播放閩南語
                                                                    </Button>
                                                                </Col>
                                                                <Col >
                                                                    <Button
                                                                        size='large'
                                                                        shape="round"
                                                                        icon={<CaretRightOutlined />}
                                                                        onClick={(e) => {
                                                                            if (pageName === "poetry_reading") {
                                                                                play(`/1203HA/1203_HA${key + 1}-${clicked_poem[0].key}`, `1203_HA${key + 1}-${clicked_poem[0].key}`, value)
                                                                            }
                                                                            else {
                                                                                message.info("目前沒有音檔可以播放")
                                                                            }
                                                                        }}
                                                                        style={{ background: '#C4C4C4', }}>
                                                                        播放客家語
                                                                    </Button>
                                                                </Col>
                                                                {
                                                                    open_player[value] && audio !== "" &&
                                                                    <audio src={audio} controls autoPlay />
                                                                }
                                                            </Row>
                                                        </Col>
                                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                                            {
                                                                MenuItem[value].map((item, index) => (
                                                                    <Row gutter={[32, 32]}>
                                                                        <Col >
                                                                            <Item
                                                                                item_index={index}
                                                                                key={index}
                                                                                item={item}
                                                                                value={item}
                                                                                onItemSelect={set_clicked_poem}
                                                                                clicked_poem={clicked_poem}
                                                                                screens={screens}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                ))
                                                            }
                                                        </Col>
                                                        <Col
                                                            xxl={{
                                                                span: 12
                                                            }}
                                                            xl={{
                                                                span: 12
                                                            }}
                                                            lg={{
                                                                span: 12
                                                            }}
                                                            md={{
                                                                span: 12
                                                            }}
                                                            sm={{
                                                                span: 0
                                                            }}
                                                            xs={{
                                                                span: 0
                                                            }}
                                                        >
                                                            <Row style={{ justifyContent: 'space-between' }}>
                                                                <Col >
                                                                    {clicked_poem && clicked_poem.map((value, index) => {
                                                                        return (
                                                                            <div>
                                                                                <div style={{ fontWeight: 700, fontFamily: '標楷體' }}>
                                                                                    <Typography.Title level={1}>
                                                                                        {value.詩名}  {value.作者}
                                                                                    </Typography.Title>
                                                                                </div>
                                                                                {value.內容.map((tmp, index) => {
                                                                                    return (
                                                                                        <div style={{
                                                                                            //  fontSize: '30px', 
                                                                                            fontWeight: 500,
                                                                                            fontFamily: '標楷體'
                                                                                        }}>

                                                                                            <Typography.Title level={3}>
                                                                                                {tmp}
                                                                                            </Typography.Title>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                            }
                                        })
                                    } />
                            </Col>
                        </Row >
                    </LocaleProvider>
                </CustomTabs>
            </Content >
        </>
    );
}
const Item = ({ item, onItemSelect, clicked_poem, screens, item_index }) => {
    const [isHovering, setIsHovering] = useState(false);
    const [show, setShow] = useState(false)
    const scrollref = useRef()
    // const screens = useBreakpoint();

    useEffect(() => {
        let click = clicked_poem.find(element => true)
        if (click && click["詩名"] === item.詩名) {
            setShow(true)
        }
        else {
            setShow(false)
        }
    }, [clicked_poem])
    const onClick = () => {
        onItemSelect([item])
        if ((screens.sm || screens.xs) && screens.md === false) {
            window.setTimeout((() =>
                scrollref.current.scrollIntoView({
                    behavior: "smooth",
                })
            ), 300);
        }
    }

    return (<Row>
        <Col span={24} ref={scrollref}>
            <div onClick={onClick}
                onMouseEnter={e => setIsHovering(true)}
                onMouseLeave={e => setIsHovering(false)}
                style={{
                    fontSize: '35px',
                    fontWeight: 500,
                    fontFamily: '標楷體',
                    color: isHovering ? 'gray' :
                        show ? '#1a0dab' : '',
                    cursor: 'pointer',
                    letterSpacing: '3px'
                }} >
                {toChinesNum(item_index + 1)}、{item.詩名}
            </div>
        </Col>
        <Col span={24}>
            <Row>
                <Col style={{ color: "#8e8787" }}>
                    播放次數： 國語 {item.播放次數.CH} 次 閩南語 {item.播放次數.TW} 次 客家語 {item.播放次數.HA} 次
                </Col>
            </Row>
        </Col>
        <Col
            xxl={{
                span: 0
            }}
            xl={{
                span: 0
            }}
            lg={{
                span: 0
            }}
            md={{
                span: 0
            }}
            sm={{
                span: 24
            }}
            xs={{
                span: 24
            }}
        >
            {show && clicked_poem && clicked_poem.map((value, index) => {
                return (
                    <Row>
                        <Col
                            span={24}
                            style={{ fontFamily: '標楷體' }}>
                            <Typography.Title level={5}
                                style={{ color: "#1a0dab" }}
                            >
                                {value.詩名}  {value.作者}
                            </Typography.Title>
                        </Col>
                        {value.內容.map((tmp, index) => {
                            return (
                                <Col style={{
                                    fontWeight: 500,
                                    fontFamily: '標楷體'
                                }}>

                                    <Typography.Title level={3}
                                        style={{ color: "#1a0dab" }}
                                    >
                                        {tmp}
                                    </Typography.Title>
                                </Col>
                            )
                        })}
                    </Row>
                )
            })}
        </Col>

    </Row >);

}
const DownloadModal = (props) => {
    const mapping_table = {
        古詩: "1",
        五言絕句: "2",
        七言絕句: "3",
        五言律詩: "4",
        七言律詩: "5",
        詞: "6"
    }
    const [languageChecked, setLanguageChecked] = useState({
        CH: false,
        HA: false,
        TW: false
    })
    const patchDownloadTime = (name) => {
        axios.patch('/poem_download', {
            name: name
        })
            .then(response => {
            })
            .catch((error) => {
                // console.error(error)
            })
            .finally(() => {
            })
    }
    const download = () => {
        let temp = []
        let name = []
        props.data[props.topic].forEach((element) => {
            element["下載"].forEach((row) => {
                temp.push(row)
                let row_split = row.split("*")
                let language = "TW"
                let language_name = "閩南語版"
                if (row_split[0].includes("CH")) {
                    language = "CH"
                    language_name = "國語版"
                }
                else if (row_split[0].includes("HA")) {
                    language = "HA"
                    language_name = "客家語版"
                }

                let url = `/music/1203${language}/${row_split[0]}.mp3`
                name.push(row_split[0])
                axios
                    .get(url, { responseType: 'blob' })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${row_split[1]}(${language_name}).mp3`); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
            })
        })
        patchDownloadTime(name)
        setLanguageChecked(pre => {
            return {
                CH: false,
                HA: false,
                TW: false
            }
        })
        props.handleOk()

    }
    const checkOnChange = (topic, index, e) => {
        props.setData(pre => {
            pre[topic] = pre[topic].map((value, rowindex) => {
                if (index === rowindex) {
                    return { ...value, "下載": e }
                }
                else {
                    return { ...value }
                }
            })
            return { ...pre }
        })
    }
    const onCheckAllChange = (topic, index, options, e) => {
        let check_value = []
        if (e.target.checked) {
            check_value = options.map((option) => (
                option.value
            ))
        }
        checkOnChange(topic, index, check_value)
    };
    const onLangueCheckChange = (e, language) => {
        if (e.target.checked) {
            let temp = props.data[props.topic].map((item, index) => (
                `1203_${language}${mapping_table[props.topic]}-${index + 1}*${item.詩名}`
            ))
            props.setData(pre => {
                let all_ = pre
                let final = all_[props.topic].map((value, rowindex) => {
                    if (value["下載"].includes(temp[rowindex])) {
                        return { ...value }
                    }
                    else {
                        return { ...value, "下載": [...value["下載"], temp[rowindex]] }
                    }
                })
                all_[props.topic] = final
                return { ...all_ }
            })

        }
        else {
            props.setData(pre => {
                let all_ = pre
                let final = all_[props.topic].map((value, rowindex) => {
                    let new_arr = value["下載"].filter((element) => element.indexOf(language) === -1)
                    return { ...value, "下載": new_arr }
                })
                all_[props.topic] = final
                return { ...all_ }
            })
        }
        setLanguageChecked(pre => {
            return {
                ...pre,
                [language]: e.target.checked
            }
        })
    }
    const onCancel = () => {

        setLanguageChecked(pre => {
            return {
                CH: false,
                HA: false,
                TW: false
            }
        })
        props.setOpen(false)
    }
    return (
        <Modal
            title={<Title level={4}>請選擇要下載的音檔</Title>}
            open={props.open}
            // onOk={props.handleOk}
            // confirmLoading={props.confirmLoading}
            onCancel={(e) => onCancel()}
            width={1000}
            footer={false}
            className="modalStyle2"
            wrapClassName={"modalStyle2"}
            bodyStyle={{ backgroundColor: '#FFDEA1', }}
        >
            <Row gutter={[10, 10]} >
                <Col>
                    <Title level={1}>{props.topic}</Title>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={12}>
                        </Col>
                        <Col span={12}>
                            < Check>
                                <Checkbox
                                    onChange={(e) => { onLangueCheckChange(e, "CH") }}
                                    checked={languageChecked.CH}
                                >
                                    國語全選
                                </Checkbox>
                                <Checkbox
                                    onChange={(e) => { onLangueCheckChange(e, "TW") }}
                                    checked={languageChecked.TW}
                                >
                                    閩南語全選
                                </Checkbox>
                                <Checkbox
                                    onChange={(e) => { onLangueCheckChange(e, "HA") }}
                                    checked={languageChecked.HA}
                                >
                                    客家語全選
                                </Checkbox>
                            </ Check>
                        </Col>
                    </Row>
                </Col>

                <Col span={24}>
                    {
                        (props.data && props.data[props.topic] || []).map((item, index) => {
                            let options = [
                                { label: '國語版', value: `1203_CH${mapping_table[props.topic]}-${index + 1}*${item.詩名}` },
                                { label: '閩南語版', value: `1203_TW${mapping_table[props.topic]}-${index + 1}*${item.詩名}` },
                                { label: '客家語版', value: `1203_HA${mapping_table[props.topic]}-${index + 1}*${item.詩名}` },
                            ];
                            return <Row >
                                <Col span={12}
                                    style={{ fontSize: '24px', alignItems: 'center', display: 'flex' }}>{item.曲目}、{item.詩名}</Col>
                                <Col span={12} className='justify-content-end'>
                                    <Row>
                                        <Col>
                                            < Check>
                                                <Checkbox
                                                    indeterminate={item["下載"].length !== 0 && item["下載"].length < options.length}
                                                    onChange={(e) => { onCheckAllChange(props.topic, index, options, e) }}
                                                    checked={item["下載"].length === options.length}
                                                >
                                                    全選
                                                </Checkbox>
                                            </ Check>
                                        </Col>
                                        <Col>
                                            < Check>
                                                <Checkbox.Group
                                                    value={item["下載"]}
                                                    key={`check_${index}`}
                                                    onChange={(e) => checkOnChange(props.topic, index, e)}
                                                    options={options}
                                                />
                                            </ Check>
                                        </Col>
                                    </Row>


                                </Col>
                                <Col span={24}>
                                    下載次數： 國語 {item.下載次數.CH} 閩南語 {item.下載次數.TW} 客語 {item.下載次數.HA}
                                </Col>
                            </Row>

                        })
                    }
                </Col>
                <Col span={24}>
                    <Row gutter={[10, 10]} justify={"end"}>
                        <Col>
                            <Button size='large' shape="round" style={{ background: '#fff', }} onClick={(e) => props.setOpen(false)}>取消</Button>
                        </Col>
                        <Col >
                            <Button size='large' shape="round" style={{ background: '#D9B3B3', }} onClick={download}>確定</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal>

    )
}

function toChinesNum(num) {
    let changeNum = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
            newNum = (i === 0 && strArr[i] === 0 ? "" : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? "" : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum;
        }
        if (newNum === "一十") {
            newNum = "十"
        }
        else if (num < 20 && num > 10) {
            newNum = newNum.replace("一", "")
        }
        return newNum || "";
    }
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}


export default Poem;
